module.exports = __webpack_public_path__ + "img/png_title2.b8dd54d0.png";